import { __rest } from "tslib";
import React, { useRef, useImperativeHandle, useMemo, } from 'react';
import styled, { css } from 'styled-components';
import { asStyledComponent } from '@clds/component-enhancer';
import TextField from '@clds/text-field';
import NumericDecorator from './components/NumericDecorator';
const InputWrapper = styled.div.attrs({ 'data-test': 'input-wrapper' }) `
  display: inline-flex;
  position: relative;
  width: 100%;
  align-items: center;
  ${({ hideDefaultNumericDecorators }) => hideDefaultNumericDecorators &&
    css `
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      input[type='number'] {
        -moz-appearance: textfield;
      }
    `}
`;
export const NumberField = (_a) => {
    var { inputRef, trailingDecoration, min, max, step, isReadonly, isDisabled, inputProps, isMobile = false, numericDecorator = true } = _a, restProps = __rest(_a, ["inputRef", "trailingDecoration", "min", "max", "step", "isReadonly", "isDisabled", "inputProps", "isMobile", "numericDecorator"]);
    const internalRef = useRef(null);
    // useImperativeHandle makes it possible to keep NumberField both controlled and uncontrolled
    // if inputRef prop is passed, it will get the ref from TextField
    // internalRef is used for the up/down buttons to control the value from the DOM and not force the
    // NumberField into controlled mode it supports both function and object {current: ...}
    useImperativeHandle(inputRef, () => internalRef.current, []);
    const renderNumberInput = useMemo(
    // eslint-disable-next-line react/display-name
    () => (input) => (React.createElement(InputWrapper, { hideDefaultNumericDecorators: !numericDecorator },
        input,
        numericDecorator && !isMobile && (
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        React.createElement(NumericDecorator, { isDisabled: isReadonly || isDisabled })))), [isDisabled, isMobile, isReadonly, numericDecorator]);
    return (React.createElement(TextField, Object.assign({}, restProps, { inputProps: Object.assign(Object.assign({}, inputProps), { min,
            max,
            step }), isReadonly: isReadonly, isDisabled: isDisabled, type: "number", trailingDecoration: trailingDecoration, inputRef: internalRef, renderCustomInput: renderNumberInput })));
};
export const StyledNumberField = asStyledComponent(NumberField);
// eslint-disable-next-line import/no-default-export
export default NumberField;
//# sourceMappingURL=NumberField.js.map